// Profile options and constants for GottaSecond

// WORK_TYPES for UI display - no duplicates
export const WORK_TYPES = [
  { value: "lead_photo", label: "Lead Photographer" },
  { value: "second_photo", label: "Second Photographer" },
  { value: "lead_video", label: "Lead Videographer" },
  { value: "second_video", label: "Second Videographer" },
  { value: "assistant", label: "Photo/Video Assistant" },
  { value: "drone_operator", label: "Drone Operator" },
  { value: "lighting_tech", label: "Lighting Technician" },
  { value: "audio_tech", label: "Audio Technician" },
  { value: "photo_editor", label: "Photo Editor" },
  { value: "video_editor", label: "Video Editor" },
  { value: "social_media_content", label: "Social Media Content" }
];

// Legacy work type aliases - used for label lookups only
export const WORK_TYPE_ALIASES = {
  "primary_photo": "Lead Photographer",
  "primary_video": "Lead Videographer", 
  "second_shooter": "Second Photographer"
};

export const GENRES = [
  { value: "wedding", label: "Wedding" },
  { value: "portrait", label: "Portrait" },
  { value: "corporate", label: "Events" },
  { value: "products", label: "Products & Branding" },
  { value: "real_estate", label: "Real Estate" },
  { value: "sports", label: "Sports" },
  { value: "concerts", label: "Concerts & Live Events" },
  { value: "fashion", label: "Fashion" },
  { value: "food", label: "Food & Beverage" },
  { value: "family", label: "Family & Newborn" },
  { value: "headshots", label: "Headshots" },
  { value: "boudoir", label: "Boudoir" },
  { value: "landscape", label: "Landscape & Travel" },
  { value: "documentary", label: "Documentary" },
  { value: "commercial", label: "Commercial" }
];

export const GENRE_LEVELS = [
  { value: "expert", label: "Expert", description: "Highly experienced, can lead" },
  { value: "comfortable", label: "Comfortable", description: "Solid experience" },
  { value: "willing_to_try", label: "Willing to Try", description: "Learning/interested" },
  { value: "not_interested", label: "Not Interested", description: "Prefer not to work in this genre" }
];

export const SHOOTING_STYLES = [
  { value: "documentary", label: "Documentary" },
  { value: "posed", label: "Posed/Traditional" },
  { value: "editorial", label: "Editorial" },
  { value: "candid", label: "Candid/Photojournalistic" },
  { value: "fine_art", label: "Fine Art" },
  { value: "lifestyle", label: "Lifestyle" },
  { value: "cinematic", label: "Cinematic" },
  { value: "black_and_white", label: "Black & White" },
  { value: "minimalist", label: "Minimalist" },
  { value: "dramatic", label: "Dramatic" },
  { value: "storytelling", label: "Storytelling" },
  { value: "artistic", label: "Artistic/Conceptual" },
  { value: "classic_timeless", label: "Classic/Timeless" }
];

export const EDITING_STYLES = [
  { value: "clean_natural", label: "Clean & Natural" },
  { value: "film_look", label: "Film Look" },
  { value: "hdr", label: "HDR" },
  { value: "matte_faded", label: "Matte/Faded" },
  { value: "vibrant_saturated", label: "Vibrant & Saturated" },
  { value: "desaturated", label: "Desaturated/Muted" },
  { value: "warm_tones", label: "Warm Tones" },
  { value: "cool_tones", label: "Cool Tones" },
  { value: "high_contrast", label: "High Contrast" },
  { value: "soft_pastel", label: "Soft & Pastel" },
  { value: "dark_moody", label: "Dark & Moody" },
  { value: "light_airy", label: "Light & Airy" },
  { value: "vintage_retro", label: "Vintage/Retro" },
  { value: "black_and_white", label: "Black & White" },
  { value: "cinematic_grade", label: "Cinematic Color Grade" },
  { value: "true_to_color", label: "True to Color" },
  { value: "skin_tone_focused", label: "Skin Tone Focused" }
];

export const LIGHTING_STYLES = [
  { value: "natural_light", label: "Natural Light" },
  { value: "off_camera_flash", label: "Off-Camera Flash" },
  { value: "on_camera_flash", label: "On-Camera Flash" },
  { value: "studio_strobe", label: "Studio Strobes" },
  { value: "continuous", label: "Continuous/Video Lights" },
  { value: "mixed_ambient", label: "Mixed/Ambient" },
  { value: "golden_hour", label: "Golden Hour" },
  { value: "backlit", label: "Backlit" },
  { value: "dramatic_lighting", label: "Dramatic/Rembrandt" },
  { value: "ring_light", label: "Ring Light" },
  { value: "bounce_flash", label: "Bounce Flash" },
  { value: "softbox", label: "Softbox" },
  { value: "led_panel", label: "LED Panels" },
  { value: "low_light", label: "Low Light Specialist" },
  { value: "flash_diffusion", label: "Flash Diffusion" }
];

export const EXPERIENCE_LEVELS = [
  { value: "novice", label: "Novice", description: "Less than 1 year" },
  { value: "starting_out", label: "Just Starting Out", description: "1-3 years" },
  { value: "established", label: "Established", description: "3+ years" }
];

export const EMPLOYMENT_TYPES = [
  { value: "full_time", label: "Full-Time Photographer" },
  { value: "part_time", label: "Part-Time / Side Gig" }
];

export const AVAILABILITY_OPTIONS = [
  { value: "both", label: "Weekdays & Weekends" },
  { value: "weekends", label: "Weekends Only" },
  { value: "weekdays", label: "Weekdays Only" }
];

export const GEAR_CATEGORIES = [
  { value: "camera", label: "Camera Bodies" },
  { value: "lens", label: "Lenses" },
  { value: "lighting", label: "Lighting" },
  { value: "audio", label: "Audio" },
  { value: "video", label: "Video" },
  { value: "drone", label: "Drone" },
  { value: "stabilization", label: "Stabilization/Gimbal" },
  { value: "other", label: "Other" }
];

export const CERTIFICATIONS = [
  { value: "drone_faa", label: "FAA Part 107 (Drone)" },
  { value: "cpr", label: "CPR Certified" },
  { value: "first_aid", label: "First Aid Certified" },
  { value: "ppa_member", label: "PPA Member" },
  { value: "wppi_member", label: "WPPI Member" }
];

export const LANGUAGES = [
  "English", "Spanish", "French", "German", "Italian", "Portuguese", 
  "Chinese (Mandarin)", "Chinese (Cantonese)", "Japanese", "Korean",
  "Vietnamese", "Tagalog", "Hindi", "Arabic", "Russian", "Polish",
  "ASL (Sign Language)", "Other"
];

// === Studio Profile Options ===

export const HIREABLE_ROLES = [
  { value: "lead_photo", label: "Lead Photographer" },
  { value: "second_photo", label: "Second Photographer" },
  { value: "lead_video", label: "Lead Videographer" },
  { value: "second_video", label: "Second Videographer" },
  { value: "assistant", label: "Photo/Video Assistant" },
  { value: "drone_operator", label: "Drone Operator" },
  { value: "lighting_tech", label: "Lighting Technician" },
  { value: "audio_tech", label: "Audio Technician" },
  { value: "photo_editor", label: "Photo Editor" },
  { value: "video_editor", label: "Video Editor" },
  { value: "social_media_content", label: "Social Media Content" }
];

export const PAYMENT_TIMING_OPTIONS = [
  { value: "same_day", label: "Same Day" },
  { value: "within_7", label: "Within 7 Days" },
  { value: "within_14", label: "Within 14 Days" },
  { value: "within_30", label: "Within 30 Days" },
  { value: "within_60", label: "Within 60 Days" }
];

export const JOB_REQUIRED_SKILLS = [
  { value: "posing_direction", label: "Posing & Direction" },
  { value: "off_camera_lighting", label: "Off-Camera Lighting" },
  { value: "lead_photographer", label: "Can Lead a Shoot" },
  { value: "second_shooting", label: "Second Shooting" },
  { value: "flash_photography", label: "Flash Photography" },
  { value: "natural_light", label: "Natural Light" },
  { value: "film_photography", label: "Film Photography" },
  { value: "detail_shots", label: "Detail Shots" },
  { value: "candid_moments", label: "Candid Moments" },
  { value: "group_shots", label: "Group/Family Shots" },
  { value: "ceremony_coverage", label: "Ceremony Coverage" },
  { value: "reception_coverage", label: "Reception Coverage" },
  { value: "drone_operation", label: "Drone Operation" },
  { value: "video_hybrid", label: "Photo + Video Hybrid" },
  { value: "editing_delivery", label: "Editing & Delivery" },
  { value: "client_interaction", label: "Client Interaction" },
  { value: "timeline_management", label: "Timeline Management" }
];

export const RATE_TYPES = [
  { value: "hourly", label: "Per Hour" },
  { value: "day_rate", label: "Day Rate" },
  { value: "flat", label: "Flat Rate" }
];

export const PORTFOLIO_USAGE_OPTIONS = [
  { value: "yes", label: "Yes, team can use images freely" },
  { value: "with_restrictions", label: "Yes, with restrictions" },
  { value: "no", label: "No, images cannot be used" }
];

export const PORTFOLIO_RESTRICTIONS = [
  { value: "after_weeks", label: "After waiting period", hasInput: true, inputLabel: "weeks" },
  { value: "must_credit_studio", label: "Must credit studio" },
  { value: "with_studio_watermark", label: "Must include studio watermark" },
  { value: "portfolio_only", label: "Portfolio use only (no marketing/ads)" },
  { value: "social_media_only", label: "Social media only" },
  { value: "must_not_tag_client", label: "Must not tag client" }
];

// Helper function to get label from value
export function getLabel(options, value) {
  // First check if it's a work type alias
  if (options === WORK_TYPES && WORK_TYPE_ALIASES[value]) {
    return WORK_TYPE_ALIASES[value];
  }
  const option = options.find(o => o.value === value);
  return option ? option.label : value;
}
